<wms-dialog id="viewChangesModal" customClasses="large project-status-container-dialog view-vcs-project-dialog">
    <wms-dialog-header (onClose)="vcsService.closeDialogWithId('viewChangesModal')"
        title="{{locale['LABEL_VCS_VIEW_PROJECT_CHANGES']}}" helpTitle="{{locale['LABEL_VCS_VIEW_PROJECT_CHANGES']}}"
        helpLink="https://docs.wavemaker.com/learn/app-development/dev-integration/developer-collaboration/#view-changes"
        customClass="pullChanges-header"></wms-dialog-header>
    <wms-dialog-body>
        <div class="form-group app-composite-widget clearfix"></div>

      <div class="wm-tabs full-height" >
          <tabset *ngIf="showMultipleTabs()"  active="ctrlScope.procedureResultTabIndex" class="full-height"   >

            <tab heading="My Changes"   [active]="vcsService.selectedTab === 'My Changes'" (selectTab)="getSelectedTab($event)"  title="My Changes">
              <div class="tab-scroll-wrapper">
              <wms-view-changes-table
                *ngIf="hasChanges('USER_CHANGES_SINCE_LAST_PULLED')"
                [fileList]="getChanges('USER_CHANGES_SINCE_LAST_PULLED')"
                [selectedFileType]="'USER_CHANGES_SINCE_LAST_PULLED'"
                [showCommitedFile]="false"
                (fileEmitter)="handleFileFromChild($event,'USER_CHANGES_SINCE_LAST_PULLED')">
              </wms-view-changes-table>
              <div *ngIf="!hasChanges('USER_CHANGES_SINCE_LAST_PULLED')" class="userChangesDefaultMsg"><p>There are no user changes.</p></div>
              </div>
            </tab>

            <tab heading="Migration Changes" *ngIf="hasChanges('MIGRATION_CHANGES_ON_LAST_PULLED')"  [active]="vcsService.selectedTab === 'Migration Changes'" (selectTab)="getSelectedTab($event)"  title="Migration Changes">
              <div class="tab-scroll-wrapper">
              <wms-view-changes-table
                [fileList]="getChanges('MIGRATION_CHANGES_ON_LAST_PULLED')"
                [selectedFileType]="'MIGRATION_CHANGES_ON_LAST_PULLED'"
                [showCommitedFile]="false"
                (fileEmitter)="handleFileFromChild($event,'MIGRATION_CHANGES_ON_LAST_PULLED')">
              </wms-view-changes-table>
              </div>
            </tab>
            <tab heading="Changes Since Last Push"  *ngIf="hasChanges('USER_CHANGES_SINCE_LAST_PUSHED')"  [active]="vcsService.selectedTab === 'Changes Since Last Push'" (selectTab)="getSelectedTab($event)" title="Changes Since Last Push">
              <div class="tab-scroll-wrapper">
              <wms-view-changes-table
                [fileList]="getChanges('USER_CHANGES_SINCE_LAST_PUSHED')"
                [selectedFileType]="'USER_CHANGES_SINCE_LAST_PUSHED'"
                [showCommitedFile]="false"
                (fileEmitter)="handleFileFromChild($event,'USER_CHANGES_SINCE_LAST_PUSHED')">
              </wms-view-changes-table>
              </div>
            </tab>

            <tab *ngIf="hasChanges('MIGRATION_CHANGES_ON_LAST_PULLED')" heading="Overall Changes"  [active]="vcsService.selectedTab === 'Overall Changes'" (selectTab)="getSelectedTab($event)"  title="Overall Changes">
              <div class="tab-scroll-wrapper">
                <wms-view-changes-table
                  *ngIf="hasChanges('OVERALL_CHANGES_SINCE_LAST_PULLED')"
                  [fileList]="getChanges('OVERALL_CHANGES_SINCE_LAST_PULLED')"
                  [selectedFileType]="'OVERALL_CHANGES_SINCE_LAST_PULLED'"
                  [showCommitedFile]="false"
                  (fileEmitter)="handleFileFromChild($event,'OVERALL_CHANGES_SINCE_LAST_PULLED')">
                </wms-view-changes-table>
                <div *ngIf="!hasChanges('OVERALL_CHANGES_SINCE_LAST_PULLED')" class="userChangesDefaultMsg"><p>There are no overall changes. Please check if you have reversed migration changes. </p></div>
              </div>
            </tab>
          </tabset>

          <div *ngIf="!showMultipleTabs()">
                  <wms-message *ngIf="vcsService.msgData.show" hideclose="true" [scopeDataset]="vcsService.msgData"></wms-message>
                  <wms-view-changes-table [fileList]="getChanges('USER_CHANGES_SINCE_LAST_PULLED')" [showCommitedFile]="false"
                      (fileEmitter)="handleFileFromChild($event,'USER_CHANGES_SINCE_LAST_PULLED')" [selectedFileType]="'USER_CHANGES_SINCE_LAST_PULLED'"></wms-view-changes-table>
                  <p class="alert app-message alert-info" *ngIf="!hasChanges('USER_CHANGES_SINCE_LAST_PULLED')">{{locale.MESSAGE_NO_FILES_VIEW}}</p>
           </div>


      </div>



<!--
-->
    </wms-dialog-body>
    <wms-dialog-footer>
      <button class="btn button-secondary app-button"
              (click)="closeDialog()">{{locale['LABEL_CANCEL']}}</button>
      <button class="btn btn-primary"
              *ngIf="projectService.teamProjectObject.vcsAccountDTO.mrFlowEnabled && vcsService.selectedTab === 'My Changes' || vcsService.selectedTab === 'Changes Since Last Push' "
              (click)="openConfirmRestoreToRTBDialog()">{{locale['LABEL_RESTORE_TO_REMOTE_BRANCH']}}</button>
      <button class="btn btn-primary" *ngIf="vcsService.selectedTab === 'My Changes' || vcsService.selectedTab === 'Changes Since Last Push' "
              (click)="revertFiles()">{{locale['LABEL_REVERT']}}</button>
    </wms-dialog-footer>
</wms-dialog>

<wms-dialog id="confirmRestoreToRTBDialog" customClasses="small">
  <wms-dialog-header title="{{locale.LABEL_RESTORE_TO_REMOTE_BRANCH}}" (onClose)="vcsService.closeDialogWithId('confirmRestoreToRTBDialog')"></wms-dialog-header>
  <wms-dialog-body>
    <p class="app-dialog-message" [innerHTML]="restoreMessage"></p>
  </wms-dialog-body>
  <wms-dialog-footer>
    <button class="cancel-action btn app-button btn-secondary" title="{{locale.LABEL_CANCEL}}"
            (click)="vcsService.closeDialogWithId('confirmRestoreToRTBDialog')"><span class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
    <button class="btn-primary ok-action btn app-button" title="{{locale.LABEL_PLAN_PROCEED}}" (click)="restoreToRemoteTrackingBranch()">
      <span class="btn-caption">{{locale.LABEL_PLAN_PROCEED}}</span></button>
  </wms-dialog-footer>
</wms-dialog>
